import React from 'react';

const DescriptionModal = ({
  showDescription,
  setShowDescription,
  modalStyles
}) => {
  if (!showDescription) return null;

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.box}>
        <button
          onClick={() => setShowDescription(null)}
          style={modalStyles.closeButton}
        >
          ×
        </button>
        <h3 style={modalStyles.modalTitle}>Description</h3>
        <p>{showDescription.Description}</p>
      </div>
    </div>
  );
};

export default DescriptionModal;
